export default {
    'menu.nomination.individual': 'Best in My Team (Nominate Individual)',
    'menu.nomination.team': 'Best in My Team (Nominate Team)',
    'nomination.onBehalfOf': 'On behalf of',
    'nomination.nominee': 'Nominee',
    'nomination.nomineeManager': 'Nominee Manager',
    'nomination.nomineeDepartment': 'Nominee Department',
    'nomination.upload': 'Upload',
    'nomination.stronglyRecommended': 'Strongly Recommended',
    'nomination.criteria': 'Criteria',
    'nomination.recognize': 'Recognize the associates who best demonstrate the company core values.',
    'nomination.coreValues': 'Core values',
    'nomination.fieldName': 'Field Name',
    'nomination.description': 'Description',
    'nomination.nominationExplanation': 'Nomination Story',
    'nomination.pleaseDescribe': 'Please describe specific reasons (Cases) to support your nomination. The length of Nomination Explanation must be between 50 characters and 2000 characters.',
    'nomination.nominatorName': 'Nominator Name',
    'nomination.nominatorDepartment': 'Nominator Department',
    'nomination.budgetSituation': 'Budget Situation',
    'nomination.showMore': 'Show More',
    'nomination.budgetDepartment': 'Budget Department',
    'nomination.awardType': 'Award Type',
    'nomination.awardBudget': 'Award Amount',
    'nomination.teamName': 'Team Name (Project Team Name)',
    'nomination.teamMember': 'Team Member',
    'nomination.Name': 'Name',
    'nomination.Department': 'Department',
    'nomination.criteriaTitle': 'Achievements or behavior that best demonstrate Corporate Core Values (Responsibility, Appreciation, Transparency, Trust and Openness). Meeting all or part of the following criteria:',
    'nomination.criteriaText1': 'Excellent achievement on certain task or project.',
    'nomination.criteriaText2': 'Being Open and Innovative in tasks or projects, with the intention towards better results or efficiency.',
    'nomination.criteriaText3': 'Great example of Cross-function Collaboration in tasks or cross function projects.',
    'nomination.criteriaText4': 'Take additional responsibilities, e.g. exceeding regular roles, go extra mile / go beyond than line function responsibilities.'

};
